// ThinkingCollapse.jsx
import React, { useState } from "react";

export default function ThinkingCollapse({ thinkingHTML }) {
  const [open, setOpen] = useState(false);

  if (!thinkingHTML) return null;

  // Aesthetic theme colors (Slate palette)
  const theme = {
    bg: "#f8fafc", // Very light slate
    border: "#e2e8f0", // Light border
    textHeader: "#334155", // Dark slate
    textContent: "#475569", // Medium slate
    accent: "#6366f1", // Indigo accent for the icon
  };

  return (
    <div
      style={{
        background: theme.bg,
        border: `1px solid ${theme.border}`,
        borderRadius: "12px",
        overflow: "hidden",
        marginBottom: "16px",
        boxShadow: open ? "0 4px 6px -1px rgba(0, 0, 0, 0.05)" : "none",
        transition: "all 0.3s ease",
      }}
    >
      {/* Toggle Header */}
      <div
        onClick={() => setOpen(!open)}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "12px 16px",
          cursor: "pointer",
          userSelect: "none",
          transition: "background 0.2s",
        }}
      >
        {/* Animated Chevron Icon */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "24px",
            height: "24px",
            marginRight: "10px",
            color: theme.accent,
            transform: open ? "rotate(90deg)" : "rotate(0deg)",
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </div>

        <span
          style={{
            fontSize: "0.95rem",
            fontWeight: 600,
            color: theme.textHeader,
            letterSpacing: "-0.01em",
          }}
        >
          Thinking Process
        </span>
      </div>

      {/* Thinking Content */}
      {open && (
        <div
          style={{
            padding: "0 16px 16px 48px", // Indented to align with text, not icon
            fontSize: "0.9rem",
            lineHeight: "1.6",
            color: theme.textContent,
            fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace', // Tech look
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          <div
            style={{
              paddingTop: "8px",
              borderTop: `1px dashed ${theme.border}`,
            }}
            dangerouslySetInnerHTML={{ __html: thinkingHTML }}
          />
        </div>
      )}
      
      {/* Inline Keyframe for simple fade animation */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-5px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}